
const state = {
  id: null,
  end_date: '',
  global: false,
  hidden: false,
  price: '',
  product_code: '',
  product_name: '',
  start_date: '',
  title: '',
}

export const requiredFields = [
  { key: 'price' },
  { key: 'title' },
]

export default state
